module.exports = __webpack_public_path__ + "assets/img/s2-tab-1-04ed1785.png";